import React, {useEffect} from 'react';
import {GiAerialSignal} from "react-icons/gi";

import zir1 from "../../assets/images/projects/zir1.png";
import zir2 from "../../assets/images/projects/zir2.png";
import zir3 from "../../assets/images/projects/zir3.png";

import exp1 from "../../assets/images/projects/exp1.png";
import exp2 from "../../assets/images/projects/exp2.png";
import exp3 from "../../assets/images/projects/exp3.png";

import law1 from "../../assets/images/projects/law1.png";
import law2 from "../../assets/images/projects/law2.png";

import port1 from "../../assets/images/projects/port1.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, FreeMode } from "swiper";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const projects = [
  {
    preview: [zir1, zir2, zir3],
    name: "E-Commerce Website",
    techs: ["HTML5", "CSS3", "JavaScript"],
    link: "https://ziyasayed.github.io/zircon/",
    description:
      "A static frontend for an eCommerce website built with VanillaJs, HTML5, and CSS3. It is one of my personal projects, the goal was to build a site with no frameworks and libraries.",
  },
  {
    preview: [exp1, exp2, exp3],
    name: "Exponential Capital",
    techs: ["ReactJs", "SaSS", "Web3 APIs"],
    link: "https://www.exponentialcapital.finance/",
    description:
      "Exponential Capital is a platform for crypto traders. I have co-build the landing page, dashboard and UI flow for the etherscan APIs.",
  },
  {
    preview: [law1, law2],
    name: "Expert Law",
    techs: ["HTML5", "CSS3", "PHP", "WordPress"],
    link: "https://www.expertlaw.co.uk/",
    description:
      "Expert Law is a law consultancy. It is a WordPress website. Developing pixel-perfect HTML from Figma was a new ultimatum for me.",
  },
  {
    preview: [port1],
    name: "This Portfolio website",
    techs: ["ReactJs", "SaSS", "Framer-motion"],
    link: "#",
    description:
      "I have built site to showcase all my work and connect to people as a frontend developer on a deeper level. Primary goal was to practise CSS animations.",
  },
];
const ProjectsTab = () => {
  const { ref, inView } = useInView();
  const controls = useAnimation();
  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        ease: "easeOut",
        delayChildren: 0.3,
        staggerChildren: 0.4, 
      },
    },
  };

  const card = {
    hidden: {
      opacity: 0,
      translateY:-30,
      translateX:-30
    },
    show: {
      opacity: 1,
      translateY:0,
      translateX:0,
      transition: {
        type: "spring",
      },
    },
  };

  
  useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);
  return (
    <motion.div className="projects" animate={controls}
    ref={ref}
    variants={container}
    initial="hidden">
      {projects.map((project, id) => {
        return (
          <motion.div className="project" key={id} variants={card}>
            <div className="projectImage projectImageDesktop">
              <div className="itemTag">Preview:</div>
              <Swiper
                slidesPerView={1}
                loop={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                modules={[Autoplay, Pagination]}
              >
                {project.preview.map((prev, id) => {
                  return (
                    <SwiperSlide key={id}>
                      <img src={prev} alt="preview" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            <div className="glass1 projectWrapper">
              <div className="projectTitle projectTitleMobile">
                {project.name}
              </div>
              <div className="projectImage projectImageMobile">
                <div className="itemTag">Preview:</div>
                <img src={project.preview[0]} alt="preview" />
              </div>

              <div className="projectTitle projectTitleDesktop glass2">
                {project.name}
              </div>

              <div>
                <div className="itemTag">Description:</div>
                <div className="projectDescription glass2">
                  {project.description}
                </div>
              </div>

              <div>
                <div className="itemTag">Tech Used:</div>
                <div className="techStacks">
                  {project.techs.map((tech, id) => {
                    return (
                      <div className="tech glass2" key={id}>
                        {tech}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="liveLink">
                <a href={project.link} target="_blank">
                  <GiAerialSignal/> Live Site
                </a>
              </div>
            </div>
          </motion.div>
        );
      })}
    </motion.div>
  );
};

export default ProjectsTab;
